module.exports = __webpack_public_path__ + "static/media/Minerva_LogoColorBlock.f749f960.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Minerva_LogoColorBlock.svg
// module id = 1259
// module chunks = 0